<!--一般信息-->
<script setup>
import { ref,reactive,watch, getCurrentInstance, onMounted, computed } from "vue";
import { useCrfStore } from "@/stores/crf";
import { useCommonStore } from "@/stores/common.js"
import { ElMessage } from "element-plus"
const crfStore = useCrfStore();
// 定义组件属性
const props = defineProps({
  formModel: {},
  mode: {
    type: String,
    default: "whole"
  },
  readonly: {
    type: Boolean,
    default: false
  },
  fold:true,
  foldbuttom:false
});
const emits = defineEmits(["phones"]);
// console.log(props.formModel,"xxxxx");

// 表单对象
const model = reactive(props.formModel);
const fold = ref(props.fold)
// console.log(model,"xxxxx");

// (年龄) 肝活检-出生日期
const dataToString = (maxdate,mindate)=>{
  // 要先判断日期是否为空，为空new Date() 会默认时间设为1970，判断错误.为空时应当赋值当前年份
    let YY = null
    let yy = null
    // 把获取到的日期统一转换格式，不然格式不统一报错
    // maxdate = new Date(maxdate)
    // mindate = new Date(mindate)
  
    // console.log(maxdate,"清0");
    maxdate? YY = new Date(maxdate).getFullYear()-0 :YY = new Date().getFullYear()-0
    mindate? yy = new Date(mindate).getFullYear()-0 : yy = 0
   
    return mindate?YY-yy:0
}
// 监听出生日期选择
watch(()=>model.fields['生日'],(newval,oldval)=>{
  // 获取非监听的时间对象需要转一下格式(统一放在计算年龄函数里面!
  if (!dataToString(model.fields['入组时间'],newval)>=0) {
    model.fields['年龄'] =  dataToString(model.fields['入组时间'],newval)
  }else{
    mode.fields['生日'] = oldval
    ElMessage.error('入组时间应大于出生时间')
  }
  
})
// 监听入组(肝活检)时间选择
watch(()=>model.fields['入组时间'],(newval,oldval)=>{
  // console.log(!dataToString(newval,model.fields['生日'])>=0)
  if (dataToString(newval,model.fields['生日'])>=0) {
    model.fields['年龄'] =  dataToString(newval,model.fields['生日'])
  }else{
    model.fields['入组时间'] = new Date(Date.now())
    ElMessage.error('入组时间应大于出生时间')
  }
  
})


// 监听体重输入是否规范
watch(()=>model.fields['体重'],(newval,oldval)=>{
  model.fields['体重'] = String(newval)?.replace(/\D/g,'')?.replace(/^0\d$/,'0')?.slice(0,3) 
})

// 监听身高输入是否规范
watch(()=>model.fields['身高'],(newval,oldval)=>{
  // console.log(new RegExp(reg).test(newval))
  model.fields['身高'] = String(newval)?.replace(/[^0-9]/g,'').replace(/^0\d$/,'0').slice(0,3) 
  // model.fields['身高'] =  newval.replace(/[^0-9]/g,'')


  let str = 'dfsdf\d434'
  let reg = /\d/
  // console.log(reg.test(str)?"'dfsdf\d434'里面包含d":'不包含')


  
});

// 记录手机号是否修改
let phonechange = ref(true)
// 监听手机号输入是否规范
watch(()=>model.fields['患者联系方式'],(newval,oldval)=>{
  if (newval && oldval&&newval != oldval) {
    phonechange.value = false
  }
  model.fields['患者联系方式'] = String(newval)?.replace(/[^0-9]/g,'').slice(0,11)
});



const disabledDate = (time) => {
  // console.log(time,Date,now())
  return time.getTime() > Date.now()
}

// 身份证后6位格式验证（出生日期DD + 3位顺序码 + 1位校验码）
// 身份证18位结构：6位地址码 + 8位出生日期(YYYYMMDD) + 3位顺序码 + 1位校验码
// 后六位就是：DD(日期2位) + 顺序码(3位) + 校验码(1位)
function validateIdLast6Digits(idStr) {
  if (!idStr || idStr.length !== 6) {
    return { valid: false, message: '身份证后六位不能为空且必须为6位' };
  }
  
  // 提取各部分
  const day = parseInt(idStr.substring(0, 2)); // 出生日期的日(DD)
  const seqCode = idStr.substring(2, 5); // 3位顺序码
  const checkCode = idStr.charAt(5).toUpperCase(); // 校验码
  
  // 基本格式验证：日期(01-31) + 3位顺序码(000-999) + 校验码(0-9或X)
  const pattern = /^(0[1-9]|[12][0-9]|3[01])\d{3}[0-9X]$/i;
  if (!pattern.test(idStr)) {
    return { valid: false, message: '身份证后六位格式不正确（应为：日期2位+顺序码3位+校验码1位）' };
  }
  
  // 日期合理性验证（日期范围01-31）
  if (day < 1 || day > 31) {
    return { valid: false, message: '日期部分必须在01-31之间' };
  }
  
  // 验证顺序码是否为数字
  if (!/^\d{3}$/.test(seqCode)) {
    return { valid: false, message: '顺序码必须为3位数字' };
  }
  
  // 验证校验码格式
  if (!/^[0-9X]$/i.test(checkCode)) {
    return { valid: false, message: '校验码必须为数字0-9或字母X' };
  }
  
  return { valid: true, message: '' };
}

// 身份证后六位输入规范化
watch(()=>model.fields['身份证后六位'], (newVal) => {
  if (newVal) {
    // 去除空格并转大写
    let formattedVal = newVal.trim().toUpperCase();
    // 只保留前6位字符
    formattedVal = formattedVal.substring(0, 6);
    // 只允许数字和X
    formattedVal = formattedVal.replace(/[^0-9X]/g, '');
    
    // 实时格式提示（不阻止输入，只在完整输入6位后验证）
    if (formattedVal.length === 6) {
      const validation = validateIdLast6Digits(formattedVal)
      if (!validation.valid) {
        // 使用更温和的提示，不阻止输入
        console.warn('身份证格式提示:', validation.message)
      }
    }
    
    model.fields['身份证后六位'] = formattedVal;
  }
});


// 身份证验证（包含格式验证和重复性检查）
const idCard = async ()=>{
  let goOver = true
  let card = model.fields['身份证后六位']
  
  if (!card) {
    ElMessage.error('请输入身份证后六位')
    return false
  }
  
  // 格式验证
  const validation = validateIdLast6Digits(card)
  if (!validation.valid) {
    ElMessage.error(validation.message)
    return false
  }
  
  // 检查是否已存在（需要传入当前患者ID，避免自己与自己冲突）
  try {
    let common = await useCommonStore().getIDcard(props.formModel.id, model.fields['身份证后六位'], model.fields['患者姓名'])
    if (common.data?.isExists) {
      goOver = false
      ElMessage.error('该患者已存在')
    }
  } catch (error) {
    console.error('检查患者是否存在时出错:', error)
    ElMessage.error('验证失败，请稍后重试')
    return false
  }
  
  return goOver
}


// 手机号验证
const phone = (mobile)=>{

    let regu = /^1\d{10}$/;
    let re = new RegExp(regu);
    if (!re.test(mobile)){
        return false;
    }
    return true;
}
let phonediolag = ref(false)
let confirm = ref(false)

// 验证弹窗点击确认
const confirmdialog = ()=>{

  phonediolag.value = false
  confirm.value = true
  emits('phones')
  // phonefun()
}

// 方法让父组件调用

const phonefun = ()=>{
  // 没有变动不做判断(直接return 跳过)
  if(phonechange.value) return phonechange.value

  if (phone(model.fields['患者联系方式']) || confirm.value) {
    // 直接提交
    confirm.value = true
  }else{
    // 提交中断(打开弹窗)
    phonediolag.value = true
  }
  // 返回是否可以提交的判断
  return confirm.value;

}

// 暴露出去才能被父级调用
defineExpose({
  idCard,
  phonefun
});
const wholeShow = ref(false);

</script>

<template class="site">
  <h2 id="一般信息">一般信息</h2>
  <el-form-item label="患者姓名" class="redStar">
    <el-input v-model="model.fields['患者姓名']" placeholder="请输入患者姓名" :readonly="readonly"></el-input>
  </el-form-item>
 
  <!-- 入选和排除标准的性别 -->
  <el-form-item v-if="readonly" label="性别" class="redStar">
    <el-radio-group v-model="model.fields['性别']" disabled >
      <el-radio label="男" prop="男" ></el-radio>
      <el-radio label="女" prop="女" ></el-radio>
    </el-radio-group>
  </el-form-item>
  <!-- 其他的性别 -->
  <el-form-item  v-if="!readonly" label="性别" class="redStar">
    <el-radio-group v-model="model.fields['性别']">
      <el-radio label="男" prop="男" ></el-radio>
      <el-radio label="女" prop="女" ></el-radio>
    </el-radio-group>
  </el-form-item>

  <el-form-item  label="出生日期" class="age redStar">
      <div class="content">
          <div class="block">
            <el-date-picker
              v-model="model.fields.生日"
              type="date"
              placeholder="请选择出生日期"
              :disabled-date="disabledDate"
              size="default"
              :readonly="readonly"
            />
          </div>
          <el-input v-model="model.fields['年龄']" placeholder="请输入年龄" autocomplete="off" class="date" disabled
                    :readonly="readonly">
            <template #append>岁</template>
          </el-input>
          <p class="tishi">年龄:出生日期到肝活检日期</p>
      </div>
  </el-form-item>
  <template v-if="fold">
      <el-form-item  v-if="props.mode==='whole'"  label="身份证后六位" class="redStar" >
        <!-- prop="fields['身份证后六位']" :rules="crfStore.textRules('身份证后六位',true,{ len: 6, message: '需要6位' })" -->
        <el-input v-model="model.fields['身份证后六位']" maxlength="6"></el-input>
      </el-form-item>
      <el-form-item :readonly="readonly" v-if="props.mode==='whole'" label="民族" class="redStar">
        <el-input v-model="model.fields['民族']" autocomplete="off" placeholder="请输入民族"
                  :readonly="readonly"></el-input>
      </el-form-item>
      <el-form-item :readonly="readonly" v-if="props.mode==='whole'" label="身高（CM）" class="redStar" >
                    <!-- prop="fields['身高']" :rules="crfStore.floatNumberRules('身高',true)"  -->
        <el-input v-model="model.fields['身高']" autocomplete="off" placeholder="请输入身高"
                  :readonly="readonly">
          <template #append>CM</template>
        </el-input>
      </el-form-item>
      <el-form-item :readonly="readonly" v-if="props.mode==='whole'" label="体重（KG）" class="redStar" >
                    <!--prop="fields['体重']" :rules="crfStore.intNumberRules('体重',true)"  -->
        <el-input v-model="model.fields['体重']" placeholder="请输入体重" autocomplete="off"
                  :readonly="readonly">
          <template #append>KG</template>
        </el-input>
      </el-form-item>
      <el-form-item :readonly="readonly" v-if="props.mode==='whole'" label="入组时间（肝活检日期）" class="redStar">
                  
          <div class="block">
            <el-date-picker
              v-model="model.fields.入组时间"
              type="date"
              placeholder="请选择入组时间"
              size="default"
            />
        </div>
      </el-form-item>

      <el-form-item :readonly="readonly" v-if="props.mode==='whole'" label="职业" class="redStar">
        <el-input v-model="model.fields['职业']" placeholder="请输入患者职业" autocomplete="off"
                  :readonly="readonly"></el-input>
      </el-form-item>

      <el-form-item :readonly="readonly" v-if="props.mode==='whole'" label="籍贯" class="redStar">
        <el-input v-model="model.fields['籍贯']" placeholder="请输入患者籍贯" autocomplete="off"
                  :readonly="readonly"></el-input>
      </el-form-item>
 
      <el-form-item :readonly="readonly" v-if="props.mode==='whole'" label="患者联系方式" class="redStar">
        <el-input v-model="model.fields['患者联系方式']" placeholder="请输入患者联系方式" autocomplete="off"
                  :readonly="readonly"></el-input>
      </el-form-item>

      <el-form-item :readonly="readonly" v-if="props.mode==='whole'" label="主诊医生姓名" class="redStar">
        <el-input v-model="model.fields['主诊医生姓名']" placeholder="请输入主诊医生姓名" autocomplete="off"
                  :readonly="readonly"></el-input>
      </el-form-item>
  </template>
  <button class="button" v-if="props.foldbuttom" @click.prevent="fold = !fold">{{fold? '折叠一般信息':'展开一般信息'}}</button>
  <!-- 手机号验证 -->
  <el-dialog
    v-model="phonediolag"
    title="提示"
    width="30%"
  >
    <span>您输入的患者联系方式不是11位手机号码，请确认联系方式是否正确</span>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="phonediolag = false">我要修改</el-button>
        <el-button type="primary" @click="confirmdialog()">确认正确</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<style lang="scss"  scoped>

.age{
    .content{
      display: block;
      // margin-left: -10px;
    }
      .block{
         margin-bottom: 20px; 
      }
    }
    .date{
      width: 150px;
    }
    .tishi{
      margin: 0;
      color: silver;
      font-size: 12px;
    }
    .button{
      position: relative;
      left: 250px;
      padding:2px 10px;
    }
</style>